










import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GLoading',
  computed: {},
  methods: {},
})
export default class GLoading extends mixins(GPageBase) {
  @Prop() displayString: string;
  mounted() {}

get dispLoadingString(): string {
    if (this.displayString) {
      return this.displayString.replace(/\n/g, '<br />');
    }
    return 'Loading';
  }
}
